import { CheckBoxFilled, CheckBoxUnfilled } from "@assets";
import { CheckBoxProps } from "./types";

export const CheckBox = ({ value, onClick, style, unfilledColor }: CheckBoxProps) => {
  return (
    <div onClick={onClick} style={style}>
      {value ? <CheckBoxFilled /> : <CheckBoxUnfilled fill={unfilledColor} />}
    </div>
  );
};
